import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["icon", "size", "variant", "mode", "disabled", "onClick", "spin"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Button, ButtonSize, ButtonMode } from '../Button';
import { Icon } from '../Icon';
import { SquircleButtonVariant } from './SquircleButton.decl';
import { makeSquircleButtonVariant, shouldForwardProp, SQUIRCLE_BUTTON_SIZES, ICON_SIZES } from './utils';
var SquircleButtonContainer = styled(Button).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "SquircleButton__SquircleButtonContainer",
  componentId: "sc-1j7qgxr-0"
})(["padding:0;align-items:center;justify-content:center;clip-path:url(#svgPath);", " ", ""], function (_ref) {
  var size = _ref.size;
  return SQUIRCLE_BUTTON_SIZES[size];
}, makeSquircleButtonVariant);
var SquircleButton = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var IconComponent = _ref2.icon,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? ButtonSize.REGULAR : _ref2$size,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? SquircleButtonVariant.PRIMARY : _ref2$variant,
      _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? ButtonMode.FILL : _ref2$mode,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      onClick = _ref2.onClick,
      spin = _ref2.spin,
      otherStyleProps = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(SquircleButtonContainer, _extends({
    ref: ref,
    size: size,
    variant: variant,
    mode: mode,
    disabled: disabled,
    onClick: onClick
  }, otherStyleProps), /*#__PURE__*/React.createElement(Icon, {
    component: IconComponent,
    size: ICON_SIZES[size],
    spin: spin
  }));
});
export default SquircleButton;